"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandsErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getBrandsErrors = [
    UseCaseError_1.UseCaseError.create('problemInProcess'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('invalidData')
];
//# sourceMappingURL=getBrandsErrors.js.map